import React from "react";
import { graphql } from "gatsby";

import SEO from "../components/SEO/SEO";
import StoriesList from "../components/Stories/StoriesList";

export default function Home({
  data: {
    strapi: {
      storyPage: { storyList },
    },
  },
  location,
}) {
  return (
    <>
      <SEO
        title="Stories"
        description={storyList.seoDescription}
        pathname={location.pathname}
      />

      {storyList && <StoriesList data={storyList} />}
    </>
  );
}

export const query = graphql`
  query storiesPageQuery {
    strapi {
      storyPage {
        seoDescription
        storyList {
          story {
            id
            slug
            title
            writtenBy
            image {
              id
              url
              imageFile {
                childImageSharp {
                  fluid(maxWidth: 500, maxHeight: 500) {
                    ...GatsbyImageSharpFluid_noBase64
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
